// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"194":"f494bb9e","568":"2e48aec5","708":"2e5c76f5","831":"88a7d0da"}[chunkId] + ".css";
};